<template>
  <q-dialog
    :visible="isVisible"
    title="查看进度"
    width="500px"
    :innerHeight="500"
    :showFooter="false"
    @close="onCancel">
    <el-timeline class="timeline">
      <el-timeline-item
        v-for="(item, index) in progressList"
        :key="index"
        :type="item.type"
        :hide-timestamp="true">
        <div class="timeline-item">
          <div class="timeline-item-title" v-html="item.title"></div>
          <div class="timeline-item-content" v-html="item.content"></div>
        </div>
      </el-timeline-item>
    </el-timeline>
  </q-dialog>
</template>

<script>
import moment from 'moment'
import {newProductStepEnum as stepEnum} from '@/utils/constant'
export default {
  name: 'PublishProgress',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    skuId: String,
    spuInfo: Object
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      progressList: []
    }
  },
  methods: {
    getDetail() {
      const params = {
        params: {
          skuId: this.skuId
        }
      };
      this.$q.newProduct.getProgressDetail(params)
        .then(({data}) => {
          let processList = [];
          data.forEach(item => {
            Object.keys(item).forEach(field => {
              item[field] = item[field] || ''
            });

            let processItem = {
              title: `${item.taskName}-${item.actualPerson || item.planActualPerson || ''}`,
              type: 'primary',
            }
            switch (+item.taskId) {
              case stepEnum.create:
                processItem.content = `
                  <div>创建时间：${item.endTime}</div>
                `;
                break;
              case stepEnum.newArrival:
                processItem.content = `
                  <div>发起时间：${item.endTime}</div>
                `;
                break;
              case stepEnum.sampleGroup:
                processItem.title = processItem.title + this.getArriavalDelayInfo(item);
                processItem.content = `
                  <div>计划到货时间：${item.planEndTime}</div>
                  <div>实际到货时间：${item.endTime}</div>
                  <div>更新人员: ${item.updateUser}</div>
                  <div>备注：${item.remark ? item.remark : ''}</div>
                `;
                break;
              case stepEnum.shooting:
              case stepEnum.retouching:
              case stepEnum.design:
              case stepEnum.sectioning:
              case stepEnum.render:
                processItem.title = processItem.title + this.getDelayedInfo(item);
                processItem.content = `
                  <div>计划时间：${item.planBeginTime} ~ ${item.planEndTime}</div>
                  <div>实际时间：${item.beginTime} ~ ${item.endTime} ${item.hisCompleteTime ? '、' + item.hisCompleteTime : '' }</div>
                  <div>更新人员: ${item.updateUser}</div>
                  <div>备注：${item.remark ? item.remark : ''}</div>
                `;
                break;
              case stepEnum.paperwork:
              case stepEnum.files:
                processItem = {
                  ...processItem,
                  title: item.taskName,
                  type: 'success',
                  content: `
                    <div>更新时间：${item.endTime}</div>
                    <div>更新人员：${item.actualPerson}</div>
                  `
                };
                break;
              case stepEnum.preparation:
              case stepEnum.finished:
                processItem.content = `
                  <div>上线时间：${item.endTime}</div>
                `;
                break;
              default:
                processItem = {
                  title: `${item.taskName}-${item.endTime}`,
                  type: 'primary',
                }
                break;
            }

            // 拍摄，增加拍摄计划 设计，增加页面计划
            if (+item.taskId === stepEnum.shooting || +item.taskId === stepEnum.design || +item.taskId === stepEnum.render ) {
              const title = +item.taskId === stepEnum.shooting 
                ? `摄影计划-${item.createdBy}`
                : +item.taskId === stepEnum.design 
                ? `页面计划-${item.createdBy}` 
                : `渲染计划-${item.createdBy}`;
              processList.push({
                title,
                type: 'primary',
                content: `
                  <div>制定时间：${item.createDate}</div>
                `,
                taskId: item.taskId
              });
            }
            
            processItem['taskId'] = item.taskId;
            processList.push(processItem);
          });
          
          // 【线下同款】不展示的节点
          if(this.spuInfo.productTypeCode == '5') {
            processList = processList.filter(v=>{
              if(v.taskId !== stepEnum.sampleGroup && v.taskId !== stepEnum.shooting && v.taskId !== stepEnum.retouching) {
                return true
              }
            })
          }

          this.progressList = processList;
        });
    },
    getArriavalDelayInfo(item) {
      const {planEndTime, endTime} = item;
      const delayEndDays = this.computeDelayDays(planEndTime, endTime);
      let delayEndInfo = delayEndDays > 0 ? `延迟${delayEndDays}天` : '';
      if (delayEndInfo) {
        delayEndInfo = `
          <span class="delay-info">(${delayEndInfo})</span>
        `;
      }
      return delayEndInfo;
    },
    getDelayedInfo(item) {
      let delayedInfo = '';
      const {planBeginTime, planEndTime, beginTime, endTime, hisCompleteTime} = item;
      //当hisCompleteTime不会空时延迟开始计算用hisCompleteTime第一位和第二位计算 为空则还是用原来的字段计算
      if(hisCompleteTime) {
        var hisCompleteTimeStart = hisCompleteTime.split("/")[0]
        var hisPlanBeginTime = hisCompleteTimeStart.split("~")[0];
        var hisBeginTime = hisCompleteTimeStart.split("~")[1];
      }
      const delayStartDays = hisCompleteTime ? this.computeDelayDays(planBeginTime, hisPlanBeginTime) : this.computeDelayDays(planBeginTime, beginTime);
      const delayStartInfo = delayStartDays > 0 ? `延迟开始${delayStartDays}天` : '';
      const delayEndDays = hisCompleteTime ? this.computeDelayDays(planEndTime, hisBeginTime) : this.computeDelayDays(planEndTime, endTime);
      const delayEndInfo = delayEndDays > 0 ? `延迟结束${delayEndDays}天` : '';


      if (delayStartInfo && delayEndInfo) {
        delayedInfo = `${delayStartInfo}/${delayEndInfo}`;
      } else {
        delayedInfo = delayStartInfo || delayEndInfo;
      }

      if (delayedInfo) {
        delayedInfo = `
          <span class="delay-info">(${delayedInfo})</span>
        `;
      }

      return delayedInfo;
    },
    computeDelayDays(startTime, endTime) {
      if (!startTime || !endTime) {
        return 0;
      }
      let delayMillSeconds = moment(endTime, 'YYYY-MM-DD').valueOf() - moment(startTime, 'YYYY-MM-DD').valueOf();
      return parseFloat((delayMillSeconds / 1000 / 60 / 60 / 24).toFixed(1));
    },
    onCancel() {
      this.isVisible = false;
    }
  },
  created() {
    this.getDetail()
  },
}
</script>

<style lang="stylus" scoped>
.timeline
  margin-top 10px
  .timeline-item
    &-title
      line-height 20px
      >>> .delay-info
        color #f23d20
    &-content
      font-size 12px
      color #999
      line-height 1.5
</style>